import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { Password } from "primereact/password";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../Components/Alert.tsx";
import { urlutenti } from "../lib/api.ts";
import "./ResetPassword.css";
import "./LoginPage.css";

const ResetPassword: React.FC = () => {
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState({
    verificationCode: false,
    newPassword: false,
    repeatPassword: false,
  });

  const showAlert = useAlert();
  const navigate = useNavigate();

  const validateFields = () => {
    const newErrors = {
      verificationCode: !verificationCode.trim(),
      newPassword: !newPassword.trim(),
      repeatPassword: !repeatPassword.trim(),
    };

    if (
      newPassword.trim() &&
      repeatPassword.trim() &&
      newPassword.trim() !== repeatPassword.trim()
    ) {
      showAlert(
        "danger",
        "Errore",
        "Le password non coincidono.",
        "bottom-end",
        3000
      );
      return false;
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateFields()) return;

    try {
      const response = await fetch(
        `${urlutenti}/reset-password?codiceVerifica=${encodeURIComponent(
          verificationCode
        )}&nuovaPassword=${encodeURIComponent(newPassword)}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        showAlert(
          "success",
          "Password reimpostata",
          "La tua password è stata aggiornata con successo.",
          "bottom-end",
          3000
        );
        navigate("/");
      } else {
        const errorData = await response.json();
        showAlert(
          "danger",
          "Errore",
          errorData.message ||
            "Errore durante la reimpostazione della password.",
          "bottom-end",
          3000
        );
      }
    } catch (error) {
      showAlert(
        "danger",
        "Errore",
        "Errore durante la richiesta.",
        "bottom-end",
        3000
      );
    }
  };

  const errorStyle = {
    border: "1px solid red",
  };

  return (
    <Container className="container-reset-password d-flex align-items-center justify-content-center">
      <div className="reset-password-form-container shadow p-4 bg-white">
        <h2 className="mb-4">Reimposta Password</h2>
        <p>
          Inserisci il codice di verifica ricevuto via mail e scegli la tua
          nuova password
        </p>
        <Form onSubmit={handleResetPassword}>
          <Form.Group controlId="verificationCode" className="mb-3">
            <Form.Label>Codice di verifica</Form.Label>
            <Form.Control
              type="text"
              placeholder="Inserisci il codice di verifica"
              value={verificationCode}
              onChange={(e) => {
                setVerificationCode(e.target.value);
                setErrors((prev) => ({ ...prev, verificationCode: false }));
              }}
              style={errors.verificationCode ? errorStyle : {}}
              className="large-input"
            />
          </Form.Group>

          <Form.Group controlId="newPassword" className="mb-3">
            <Form.Label>Nuova Password</Form.Label>
            <Password
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setErrors((prev) => ({
                  ...prev,
                  newPassword: false,
                }));
              }}
              inputStyle={{
                width: "100%",
                height: "46px",
                display: "block",
                borderRadius: "8px",
                ...((errors.newPassword || newPassword !== repeatPassword) &&
                  errorStyle),
              }}
              style={{
                width: "100%",
                display: "block",
                height: "46px",
                borderRadius: "8px",
              }}
              placeholder="Inserisci nuova password"
              toggleMask
            />
          </Form.Group>

          <Form.Group controlId="repeatPassword" className="mb-3">
            <Form.Label>Ripeti Nuova Password</Form.Label>
            <Password
              value={repeatPassword}
              onChange={(e) => {
                setRepeatPassword(e.target.value);
                setErrors((prev) => ({
                  ...prev,
                  repeatPassword: false,
                }));
              }}
              style={{
                width: "100%",
                display: "block",
                height: "46px",
                borderRadius: "8px",
              }}
              inputStyle={{
                width: "100%",
                height: "46px",
                display: "block",
                borderRadius: "8px",
                ...((errors.newPassword || newPassword !== repeatPassword) &&
                  errorStyle),
              }}
              placeholder="Ripeti nuova password"
              toggleMask
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 button">
            Reimposta Password
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default ResetPassword;
